// extracted by mini-css-extract-plugin
export default {"loader":"InfiniteLoader_loader--DuN","ref":"InfiniteLoader_ref--SpP"};